import $http from "../axios";

const state = {
  organization: {},
  organizationBeingEdited: {}
};

const getters = {
  organization: state => {
    return state.organization;
  },

  organizationBeingEdited: state => {
    return state.organizationBeingEdited;
  }
};

const actions = {
  createOrganization({ commit }, oe) {
    return new Promise((resolve, reject) => {
      $http
        .post("create-organization", oe)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_USER_CAN_CREATE_ORGANIZATION", false);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  checkOrganizationApproved({ commit }) {
    return new Promise((resolve, reject) => {
      $http
        .get("check-organization-approved")
        .then(res => {
          if (
            res.data.result === "ok" &&
            res.data.payload.isOrganizationLeader === true
          ) {
            commit("SET_USER_IS_ORGANIZATION_LEADER", true);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  getOrganizationProfile({ commit }) {
    return new Promise((resolve, reject) => {
      $http
        .get("organization-profile")
        .then(res => {
          if (res.data.result === "ok" && res.data.payload.organization) {
            commit("SET_ORGANIZATION_DATA", res.data.payload.organization);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  setOrganizationBeingEdited({ commit }, organization) {
    commit("SET_ORGANIZATION_BEING_EDITED", organization);
  },

  checkStudentEmail(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("check-student-email", { email: data.email })
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updateOrganizationLeader({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("update-organization-leader", data)
        .then(res => {
          if (res.data.result === "ok") {
            if (data.oldLeaderEmail === state.organization.leader1.email)
              commit("CHANGE_ORGANIZATION_LEADER1", data);
            else if (data.oldLeaderEmail === state.organization.leader2.email)
              commit("CHANGE_ORGANIZATION_LEADER2", data);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updateOrganization({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("update-organization-profile", data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_ORGANIZATION_DATA", res.data.payload.oe);
            // commit("UPDATE_ORGANIZATION_STATUS");
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  sendRecommendation(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("send-recommendation", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  deleteOrganizationLogo({ commit }) {
    return new Promise((resolve, reject) => {
      $http
        .post("delete-organization-logo")
        .then(res => {
          if (res.data.result === "ok") {
            commit("DELETE_ORGANIZATION_LOGO");
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  deleteOrganization() {
    return new Promise((resolve, reject) => {
      $http
        .post("delete-organization")
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_ORGANIZATION_DATA(state, data) {
    state.organization = data;
  },

  SET_ORGANIZATION_BEING_EDITED(state, organization) {
    state.organizationBeingEdited = organization;
  },

  UPDATE_ORGANIZATION_STATUS(state) {
    state.organization.status = "active";
  },

  CHANGE_ORGANIZATION_LEADER1(state, data) {
    state.organization.leader1.email = data.newLeaderEmail;
    state.organization.leader1.position = data.newLeaderPosition;
    state.organization.leader1.areacode = data.newLeaderAreaCode;
    state.organization.leader1.cellphone = data.newLeaderCellphone;
    state.organization.leader1.name = data.newLeaderName;
    state.organization.leader1.surname = data.newLeaderSurname;
    state.organization.leader1.course = data.newLeaderCourse;
    state.organization.leader1.googlePictureURL = "";
    state.organization.leader1.picture = "";
    state.organizationBeingEdited.leader1 = state.organization.leader1;
  },

  CHANGE_ORGANIZATION_LEADER2(state, data) {
    state.organization.leader2.email = data.newLeaderEmail;
    state.organization.leader2.position = data.newLeaderPosition;
    state.organization.leader2.areacode = data.newLeaderAreaCode;
    state.organization.leader2.cellphone = data.newLeaderCellphone;
    state.organization.leader2.name = data.newLeaderName;
    state.organization.leader2.surname = data.newLeaderSurname;
    state.organization.leader2.course = data.newLeaderCourse;
    state.organization.leader2.googlePictureURL = "";
    state.organization.leader2.picture = "";
    state.organizationBeingEdited.leader2 = state.organization.leader2;
  },

  DELETE_ORGANIZATION_LOGO(state) {
    state.organization.logo = null;
  },

  CLEAR_ORGANIZATION_DATA(state) {
    state.organization = {};
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
